<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>BRAC - Accounts</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">BRAC - Accounts</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="BracBranchAccount">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'BracBranchAccountList'}"><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label">Name</label>
                    <input type="text" id="name" name="name"
                           v-bind:class="{'has-error' : errors.has('name')}"
                           v-validate="'required'"
                           v-model="value.name" class="form-control name"
                           placeholder="Name">
                    <div class="help text-danger" v-show="errors.has('name')">
                      {{ errors.first("name") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Mobile number</label>
                    <input type="text" id="mobile_number" name="mobile_number"
                           v-bind:class="{'has-error' : errors.has('mobile_number')}"
                           v-validate="'required'"
                           v-model="value.mobile_number" class="form-control mobile_number"
                           placeholder="Mobile number">
                    <div class="help text-danger" v-show="errors.has('mobile_number')">
                      {{ errors.first("mobile_number") }}
                    </div>
                  </div>
<!--                  <div class="form-group ">
                    <label class="control-label">Email</label>
                    <input type="text" id="email" name="email"
                           v-model="value.email" class="form-control email"
                           placeholder="Email">
                  </div>-->
                  <div class="form-group required">
                    <label class="control-label">Coupon Number</label>
                    <input type="text" id="coupon" name="coupon" v-validate="'required'"
                           v-model="value.coupon" class="form-control coupon"
                           placeholder="Coupon">
                    <div class="help text-danger" v-show="errors.has('coupon')">
                      {{ errors.first("coupon") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label" for="branch_name">Branch name</label>
                    <input type="text" id="branch_name" name="branch_name" v-validate="'required'"
                           v-model="value.branch_name" class="form-control branch_name"
                           placeholder="Branch name">
                    <div class="help text-danger" v-show="errors.has('branch_name')">
                      {{ errors.first("branch_name") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Branch Code</label>
                    <input type="text" id="branch_code" name="branch_code" v-validate="'required'"
                           v-model="value.branch_code" class="form-control branch_code"
                           placeholder="Branch Code">
                    <div class="help text-danger" v-show="errors.has('branch_code')">
                      {{ errors.first("branch_code") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">VO code</label>
                    <input type="text" id="vo_code" name="vo_code" v-validate="'required'"
                           v-model="value.vo_code" class="form-control vo_code"
                           placeholder="VO code">
                    <div class="help text-danger" v-show="errors.has('vo_code')">
                      {{ errors.first("vo_code") }}
                    </div>
                  </div>

                  <div class="form-group" v-if="is_edit">
                    <label class="control-label">Status</label>
                    <el-select v-model="value.status" id="status" style="width: 100%;" filterable
                               placeholder="Status">
                      <el-option
                        v-for="item in [
                            {value: 'pending', label: 'Pending'},
                            {value: 'created', label: 'Created'},
                            {value: 'rejected', label: 'Rejected'}
                          ]"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </div>
                </div>
                <div class="col-4">

                  <!--<button type="button" v-if="is_edit && profile.role === 'Administrator'"
                          class="btn btn-primary"
                  @click="createStudent">Create Student Account</button>-->

                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'
import {mapGetters} from 'vuex'

export default {
  name: 'BracBranchAccountForm',
  metaInfo: {
    title: 'Brac Branch Account | Dotlines'
  },
  components: {
    DatePicker
  },
  computed: {
    ...mapGetters(['profile'])
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
      status: 'pending'
    },
    pre: {}
  }),
  methods: {
    handleSubmission() {
      let _this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = '/brac_branch_accounts'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/brac_branch_accounts/' + _this.$route.params.id
            method = 'PUT'
          }
          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: {'Content-Type': 'application/json'},
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.$router.push({'name': 'BracBranchAccountList'})
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message)
            }
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          })
        }
      })
    },

    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/brac_branch_accounts/' + id
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            //console.log('error ' + error)
            reject(error)
          })
      })
    },

    createStudent() {
      const _this = this
      let params = this.$route.params
      const api_url = '/brac_branch_accounts/' + params.id + '/create_student_user'

      _this.$swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, create it!'
      }).then((result) => {
        if (result.isConfirmed) {
          _this.is_loading = true
          axios.post(api_url)
            .then(response => {
              _this.$toaster.success(response.data.message)
            })
            .catch(error => {
              console.log(error)
              _this.$swal.fire(
                'Failed!',
                'failed to create.',
                'error'
              )
            })
            .finally(() => {
              _this.is_loading = false
            })
        }
      })
    },

    async initialize() {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data
        }).catch((error) => {
          console.log(error.response)
        })
      }
      this.is_loading = false
    }
  },
  mounted() {
    this.initialize()
  }
}
</script>

